import React from 'react'

export default function Card({
  children,
  className = '',
  hover = false,
  padding = 'md',
  onClick,
  ...props
}) {
  const paddingSizes = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  }

  const baseClasses = `
    bg-white rounded-xl shadow-sm border border-slate-200
    ${paddingSizes[padding]}
  `

  const hoverClasses = hover
    ? 'hover:shadow-md hover:border-primary-200 transition-all duration-200 cursor-pointer'
    : ''

  return (
    <div
      className={`${baseClasses} ${hoverClasses} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  )
}

// Card Header component
export function CardHeader({ children, className = '' }) {
  return (
    <div className={`pb-4 border-b border-slate-200 mb-4 ${className}`}>
      {children}
    </div>
  )
}

// Card Title component
export function CardTitle({ children, className = '' }) {
  return (
    <h3 className={`text-lg font-semibold text-slate-900 ${className}`}>
      {children}
    </h3>
  )
}

// Card Description component
export function CardDescription({ children, className = '' }) {
  return (
    <p className={`text-sm text-slate-500 mt-1 ${className}`}>
      {children}
    </p>
  )
}

// Card Content component
export function CardContent({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  )
}

// Card Footer component
export function CardFooter({ children, className = '' }) {
  return (
    <div className={`pt-4 border-t border-slate-200 mt-4 ${className}`}>
      {children}
    </div>
  )
}

// Stat Card for dashboard
export function StatCard({ title, value, icon: Icon, trend, className = '' }) {
  return (
    <Card className={className}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <p className="text-3xl font-bold text-slate-900 mt-1">{value}</p>
          {trend && (
            <p className={`text-sm mt-2 ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {trend > 0 ? '+' : ''}{trend}% from last month
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-3 bg-primary-50 rounded-lg">
            <Icon className="w-6 h-6 text-primary-700" />
          </div>
        )}
      </div>
    </Card>
  )
}
